module.exports = __webpack_public_path__ + "img/accessory_shirt_01.8420ae82.svg";